import { createMuiTheme } from '@material-ui/core/styles';

export const textColor = '#fff';
export const altTextColor = '#000';
export const mainColor = '#2196f3';
export const altMainColor = '#82b1ff';
export const errorColor = '#ff5252';
export const altErrorColor = '#ff867f';
export const successColor = '#009688';
export const warningColor = '#ffff00';
export const backgroundColor = '#fafafa';
export const defaultColor = '#e0e0e0';
export const fontFamily = '"Exo 2", sans-serif';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: mainColor
    },
    secondary: {
      main: errorColor
    }
  },
  typography: {
    fontFamily
  }
});
